import React, { Component } from "react"
import * as strings from "../../../strings"
import Yup from "../../../lib/Yup"
import FormikDialog from "../../../components/FormikDialog"
import _ from "lodash"
import styles from "./styles.css"
import * as FormikComponents from "../../../components/FormikComponents"

const DEFAULT_PAYMENT_METHODS = [
  "Transferência",
  "Depósito",
  "Cheque",
  "Vale de Correio",
  "Numerário",
  "Multibanco",
]


const DEFAULT_PAYMENT = {
  value: "",
  paymentDate: new Date(),
  paymentMethod: undefined,
  isLastPayment: false,
  documents: [],
}

const PAYMENT_SCHEMA = Yup.object().shape( {
  paymentDate: Yup
    .date()
    .required(),
  paymentMethod: Yup
    .string(),
  value: Yup
    .number()
    .positive()
    .required(),
  isLastPayment: Yup
    .boolean()
    .required(),
  documents: Yup
    .mixed()
    .nullable(),
} )


class PaymentDialog extends Component {
  props: {
    visible: boolean,

    payment: mixed,
    savePayment: Function,
    deletePayment: Function,
    cancel: Function,
    downloadPaymentDocument: Function
  }

  render () {
    const payment = this.props.payment || DEFAULT_PAYMENT
    const onDelete = _.get( this.props, "payment.id", undefined )
      ? this.props.deletePayment
      : undefined


    return (
      <FormikDialog
        title={strings.paymentAgreements.addPayment}
        yupSchema={PAYMENT_SCHEMA}
        initialValues={payment}
        visible={this.props.visible}

        onSave={this.props.savePayment}
        onCancel={this.props.cancel}
        onDelete={onDelete}
      >
        <div>
          <div className={styles.rowInputs}>
            <FormikComponents.Input
              label={strings.paymentAgreements.paymentValue}
              type="number"
              step="0.01"
              name="value"
            />
            <FormikComponents.DatePicker
              label={strings.generalStrings.paymentDate}
              name="paymentDate"
            />
            <FormikComponents.Autocomplete
              allowCreate
              showSuggestionsWhenValueIsSet
              direction="down"
              multiple={false}
              label={strings.paymentAgreements.paymentMethod}
              source={DEFAULT_PAYMENT_METHODS}
              name="paymentMethod"
            />
          </div>
          <div className={styles.rowInputs, styles.checkBoxFix}>
            <FormikComponents.Checkbox
              label={strings.generalStrings.lastPayment}
              name="isLastPayment"
            />
          </div>
          <div className={styles.uploadWrapper}>
            <FormikComponents.FilePicker
              label={strings.generalStrings.proofDocument}
              name="documents"
              canDeleteFiles
              onFileClick={() => this.props.downloadPaymentDocument( payment )}
            />
          </div>
        </div>
      </FormikDialog>
    )
  }
}


export default PaymentDialog



// WEBPACK FOOTER //
// ./src/views/PaymentAgreement/PaymentsTracking/PaymentDialog.jsx